import * as api from '../../api/user';
import { PermissionType } from '../../../constant';

export const getUserInfo = () =>
  new Promise((resolve) => {
    api.getUserInfo().then((response) => {
      const { code, value } = response;
      // 格式化数据
      if (code === 1) {
        const { userInfo, applications } = value;
        const applicationList =
          applications?.map((item) => {
            const { appId, name, title, permissions, attributes = [] } = item;
            const application = { appId, name, title, permissions };
            /**
             * 在超管系统配置时，由于 URL 唯一性的需要，加上了前缀。
             * 因此在此处需要去除。
             */
            const urlPatern = new RegExp(`^/${name}/pc`);
            const dirs = (application.permissions || []).filter(
              (perm) => perm.type === PermissionType.DIRECTORY,
            );

            attributes?.forEach((attribute) => {
              const type = attribute.name;
              const attributeValue = attribute.value;

              try {
                (application)[type] = JSON.parse(attributeValue);
              } catch (error) {
                (application)[type] = attributeValue;
              }
            });

            application.pages = dirs.map((dir) => ({
              title: dir.name,
              path: dir.url.replace(urlPatern, ''),
            }));

            return application;
          }) || [];

        resolve({ code, value: { userInfo, applications: applicationList } });
      } else {
        resolve(response);
      }
    });
  });

  // 获取U校园用户信息
  export const checkUserInfo = (params) =>
    new Promise((resolve, reject) => {
      api.checkUserInfo(params)
        .then((rs) => {
          resolve(rs);
        }, (error) => {
          reject(error);
        });
    });
